import { TagIcon } from "lucide-react";
import { Badge } from "../ui/badge";

export const TagsRenderer = ({ tagNames }: { tagNames: string[] }) => {
  return (
    <>
      {tagNames.map((tagName) => (
        <Badge key={tagName} className="bg-primary/80 text-primary-foreground">
          <TagIcon className="w-4 h-4" />
          {tagName}
        </Badge>
      ))}
    </>
  );
};
